import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import * as AlertNotification from '@givebutter/primitives/alert-notification';
import { SearchActions } from 'components/search/SearchActions';
import { SearchCampaignsResults } from 'components/search/SearchCampaignsResults';
import { SearchCompaniesResults } from 'components/search/SearchCompaniesResults';
import { SearchContactsResults } from 'components/search/SearchContactsResults';
import { SearchEmptyResults } from 'components/search/SearchEmptyResults';
import { SearchHelpCenter } from 'components/search/SearchHelpCenter';
import { SearchHelpCenterResults } from 'components/search/SearchHelpCenterResults';
import { SearchPlansResults } from 'components/search/SearchPlansResults';
import { SearchTicketsResults } from 'components/search/SearchTicketsResults';
import { SearchTransactionResults } from 'components/search/SearchTransactionResults';
import { SEARCH_RESULTS } from 'components/search/selectors';
import { useSearchStore } from 'components/search/useSearchStore';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const SearchResultsList = () => {
    const { listRef } = useSearchStore();
    const { search_api_key } = useCurrentAccount();

    return (
        <Suspense fallback={null}>
            <label htmlFor={`#${SEARCH_RESULTS}`} className={'sr-only'}>
                Search results
            </label>
            <div
                id={SEARCH_RESULTS}
                role={'listbox'}
                aria-label={'Search results'}
                className={'flex flex-col gap-1 px-2 pb-2'}
                ref={listRef}
            >
                <ErrorBoundary
                    resetKeys={[search_api_key]}
                    fallback={
                        <AlertNotification.Root type={'error'} className={'my-2'}>
                            We're having trouble making your request. Please try again in a few
                            minutes.
                        </AlertNotification.Root>
                    }
                >
                    <SearchContactsResults />
                    <SearchCompaniesResults />
                    <SearchTransactionResults />
                    <SearchCampaignsResults />
                    <SearchPlansResults />
                    <SearchTicketsResults />
                    <SearchHelpCenterResults />
                </ErrorBoundary>
                <SearchActions />
            </div>
            <ErrorBoundary fallback={null} resetKeys={[search_api_key]}>
                <SearchEmptyResults />
            </ErrorBoundary>
            <SearchHelpCenter />
        </Suspense>
    );
};

export { SearchResultsList };
